import React from "react";
import { Row, Col } from "reactstrap";

const ProSeInfo = (props) => {
  return (
    <Row className="pr-0 pl-0 psInfo">
      <Col>
        <h2 className="text-center text-uppercase">
          Federal Court Advice-Only Clinic
        </h2>
        <hr />
        <p className="mx-auto text-center padTop">
          Welcome to the new Advice-Only Clinic. Whether you are a new user or
          used our old application you will need to register an account. Once
          you have registered you can then fill out a questionnaire and request
          a meeting.
        </p>
        <hr />
        <p className="mx-auto text-center padTop">
          {/* Volunteer lawyers provide consultations by appointment for individuals
          who cannot afford a lawyer and who are representing themselves in
          civil lawsuits. Volunteer lawyers will provide consultations at the
          court for 20 - 30 minutes without charge on the second and fourth
          Thursdays of each month, between 12:00 p.m. and 4:00 p.m. */}
          Volunteer lawyers will provide phone consultations for 20-30 minutes without charge for scheduled appointments.
        </p>
      </Col>
    </Row>
  );
};
export default ProSeInfo;
